var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPptColorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 22.76,
    viewBox: "0 0 17.36 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PPT",
    transform: "translate(-1 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M18.35,22.08a.681.681,0,0,1-.67.69H1.67A.681.681,0,0,1,1,22.08V.7A.681.681,0,0,1,1.67.01H13.48c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M18.35,15.86H1v6.2a.681.681,0,0,0,.67.69H17.69a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#cc4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M13.51.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M5.94,20.08v1.23H5.37v-3.3H6.63a1.6,1.6,0,0,1,.51.08,1.185,1.185,0,0,1,.38.22.938.938,0,0,1,.23.33,1.122,1.122,0,0,1,.08.42,1.176,1.176,0,0,1-.08.43.821.821,0,0,1-.23.32.922.922,0,0,1-.38.2,1.964,1.964,0,0,1-.51.07Zm0-.46h.69a.789.789,0,0,0,.28-.04.666.666,0,0,0,.2-.12.418.418,0,0,0,.11-.18.8.8,0,0,0,.03-.23.732.732,0,0,0-.03-.22.524.524,0,0,0-.11-.19.464.464,0,0,0-.2-.13.778.778,0,0,0-.28-.05H5.94v1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M8.91,20.08v1.23H8.34v-3.3H9.6a1.6,1.6,0,0,1,.51.08,1.185,1.185,0,0,1,.38.22.938.938,0,0,1,.23.33,1.122,1.122,0,0,1,.08.42,1.176,1.176,0,0,1-.08.43.821.821,0,0,1-.23.32.922.922,0,0,1-.38.2,1.964,1.964,0,0,1-.51.07H8.91Zm0-.46H9.6a.788.788,0,0,0,.28-.04.666.666,0,0,0,.2-.12.418.418,0,0,0,.11-.18.8.8,0,0,0,.03-.23.732.732,0,0,0-.03-.22.524.524,0,0,0-.11-.19.464.464,0,0,0-.2-.13.778.778,0,0,0-.28-.05H8.91v1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M13.69,18.47H12.66v2.84h-.57V18.47H11.07v-.46h2.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M13.35,9.14H9.51V5.3A3.841,3.841,0,0,1,13.35,9.14Z",
    fill: "#cc4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M8.85,9.8V5.96A3.84,3.84,0,1,0,12.69,9.8Z",
    fill: "#cc4c4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptColorIcon);
export default __webpack_public_path__ + "static/media/ppt-color-icon.4ade92e57e149e3b57819d9d0e273480.svg";
export { ForwardRef as ReactComponent };